import * as yup from 'yup';

export default yup.object().shape({
  reason: yup.string().trim().required('Reason is required'),
  type: yup.string().required('Type is required'),
  activityType: yup.string().required('ActivityType is required'),
  amount: yup.number().required('Amount is required'),
});
